import React, { useState, useEffect } from 'react';
import {
    Box,
    Center,
    Heading,
    HStack,
    Image,
    Link,
    Text,
} from "native-base";
import Subscribe from './Subscribe';

const image = require('../../assets/icon.png');

const Header = () => {
    return (
        <Box bg="white" h="7%">
            <Link href="/">
                <HStack alignItems="center">
                    <Image
                        source={image}
                        size="sm"
                        mt="4"
                        mb="4"
                        ml="4"
                    />
                    <Heading size="sm">
                        Invite Me Not
                    </Heading>
                </HStack>
            </Link>
            {/* <Subscribe position="relative" top="" mt="-4"></Subscribe> */}
        </Box>
    );
}

export default Header;